<template>
  <div id="text-classification-tab-wrapper">
    <div v-if="classifyState === RunStates.NOT_RUN" id="classify_not_run">
      When you run an analysis to classify a text, the results will appear here.
    </div>
    <div v-if="classifyState === RunStates.RUNNING"><spinner></spinner></div>
    <div v-if="classifyState === RunStates.FAILED" id="classify_failed" class="no-txt">
      <h3>Server failed to respond.</h3>
      <button type="button" @click="hideElement('#classify_failed')" class="button hoverable pull-right"><div class="anim"></div><img src="../../assets/ic_cancel_small.png"> Close</button>
    </div>
    <div v-if="classifyState === RunStates.TIMED_OUT" id="classify_timed_out" class="no-txt">
      <h3>Server took too long to respond.</h3>
      <button type="button" @click="hideElement('#classify_timed_out')" class="button hoverable pull-right"><div class="anim"></div><img src="../../assets/ic_cancel_small.png"> Close</button>
    </div>
    <div v-if="classifyState === RunStates.COMPLETE">
            <div class="heading-area">
              <div class="btn-group dropdown pull-right">
                <p class="title">View</p>
                <div class="md-select non-dropdown-closer" :class="{active:view}" @click="view = !view">
                  <label for="ul-id"><button type="button" class="ng-binding">{{ dropDownSelection }}</button></label>
                  <ul role="listbox" id="ul-id" class="md-whiteframe-z1" name="ul-id">
                    <li v-for="(choice, index) in dropDownChoices" :key="index" v-on:click="userSelect(choice)" role="option" id="state1" class="ng-binding ng-scope active" tabindex="-1" aria-selected="true">{{ choice }}</li>
                  </ul>
                </div>
              </div>
              <div class="row">
                <div v-if="dropDownSelection === 'Divide text into chapters'" class="col-xs-12">
                  <h2>Confidence</h2>
                  <div class="chart-holder">
                    <div class="chartBarsWrap">
                      <div class="chartBars chartBars3">
                        <ul class="numbers">
                          <li><span>High</span></li>
                          <li class="center"><span>Mid</span></li>
                          <li class="bottom"><span>Low</span></li>
                        </ul>
                        <ul class="bars">
                          <li v-for="result in testSetResults" :key="result.index">
                            <div :class="barColor(result)" :title="result.name.split('/').slice(4,6).join('/')" class="bar trigger" v-bind:data-percentage="scaleConfidence(result.confidence)">
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <advanced-info-popup v-bind:chunk-results="chosenResult"></advanced-info-popup>
            <div v-for="result in testSetResults" :key="result.index">
              <div class="heading-area margin">
                <div class="row">
                  <div class="col-xs-12">
                    <h2>{{ getResultName(result) }}</h2>
                  </div>
                </div>
              </div>
              <div class="text">
                <div v-bind:class="textColor(result)"></div>
                <div class="row">
                  <div class="col-xs-9">
                    <div class="row">
                      <div class="col-xs-2" style="min-width: 120px">
                        <p><strong>Classification </strong></p>
                      </div>
                      <div class="col-xs-7">
                        <p>{{ result.classifiedAs }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-2" style="min-width: 120px">
                        <p><strong>Confidence </strong></p>
                      </div>
                      <div class="col-xs-7">
                        <p v-if="result.confidence <= 0.75">Low</p>
                        <p v-if="result.confidence > 0.75 && result.confidence < 0.9">Medium</p>
                        <p v-if="result.confidence >= 0.9">High</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-3">
                    <a v-on:click="focus(result)" data-toggle="modal" data-target="#view_advanced_information" class="pull-right f gray" href="#">View advanced info</a>
                  </div>
                </div>
              </div>
              <div class="txtblock" :class="{active: result.show}" @click="toggleShow(result.index)">
                <a class="opentxt f gray" ><span style="font-size: 14px" v-if="!(result.show)">Show</span><span style="font-size: 14px" v-if="result.show">Hide</span> Text</a>
                <div v-if="result.show" class="slidetxt" style="display: block">
        <!--          <p class="black">{{ result.name.split('/').slice(4,6).join('/') }}</p>
                  <ul class="verses-list"> -->
                  <div class="verses-list">
                    <span v-if="result.loading"><br /><spinner></spinner></span>
                    <p class="error-message" v-if="result.timedOut">
                      Server took too long to respond.
                    </p>
                    <p class="error-message" v-if="result.failed">
                      Server failed to provide the necessary response.
                    </p>
                    <div v-for="chunk in result.arrangedReviewText" :key="chunk.chunkID">
                      <p><strong>{{ getChunkHeader(chunk) }}</strong></p>
                      <ul>
                        <li v-for="pasuk in chunk.pesukim" :key="pasuk.chunkKey">
                          <a href="#">
                            <em class="first-word">{{ pasukHeb(pasuk.chunkKey) }}</em>
                            <span>
                              {{ pasuk.text }}
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
        <!--          </ul> -->
                </div>
              </div>
            </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import AdvancedInfoPopup from './advancedInfoPopup.vue'
import inventedDataJson from '../../../static/inventedTestSetResults.json'
import textMixins from '../../mixins/textMixins'
import axios from 'axios/index'
import _ from 'lodash'
import Spinner from '../spinner'
// (now used only in downloadFunctionMixins) import {RunStates} from '../../store/runStates'
import {Actions, StateChanges} from '../../store/stateChanges'

import downloadFunctionMixins from '../../mixins/downloadFunctionMixins'
// the above contains the functions getResultName() and updateTestTextResults()

function numToHebrew (num) {
  const ones = num % 10
  const tens = (num - ones) / 10 % 10
  const hundreds = (num - tens * 10 - ones) / 100
  let result = ''
  if (hundreds) { result = 'dקרשת'[hundreds] }
  if (tens === 1 && ones === 5) {
    result += 'טו'
  } else if (tens === 1 && ones === 6) {
    result += 'טז'
  } else result += (tens ? 'dיכלמנסעפצ'[tens] : '') + (ones ? 'dאבגדהוזחט'[ones] : '')
  return result
};

function bookChapterAndVerse (key) {
  let matches = /\/Tanakh\/[^/]*\/([^/]*)?(?:\/Chapter ([^/]*))?(?:\/Pasuk (.*))?/.exec(key)
  if (!matches) {
    // (old version) return _.drop(/Tanakh\/([^/]*)/.exec(key))
    console.log('key:')
    console.log(key)
    return []
  }
  matches.shift()
  return _.compact(matches)
}

export default {
  name: 'textClassificationTab',
  components: {
    AdvancedInfoPopup,
    Spinner
  },
  mixins: [textMixins, downloadFunctionMixins],
  inventedData: inventedDataJson, // using "custom option" because it's static data
  data () {
    return {
      view: false,
      testSetResults: [],
      chosenResult: {
        name: '(not yet populated)',
        featureList: []
      },
      dropDownUserSelection: this.$store.state.chunking === 'DEFAULT' ? 'Divide text into chapters' : 'Entire Text (Don’t divide)'
    }
  },
  computed: {
    dropDownChoices: function () {
      let choices = ['Entire Text (Don’t divide)']
      if (this.testSetResults.length > 1 || this.$store.state.chunking === 'SINGLE') {
        if (this.dropDownUserSelection === 'Entire Text (Don’t divide)') {
          choices.push('Divide text into chapters')
        } else {
          choices.unshift('Divide text into chapters')
        }
      }
      return choices
    },
    dropDownSelection: function () {
      return this.dropDownUserSelection ? this.dropDownUserSelection : this.dropDownChoices[0]
    }
  },
  methods: {
    hideElement: function (idString) {
      $(idString).hide()
    },
    scrollReveal () {
      var piesiteFired = 0
      var $win = $(window)
      var $winHeight = $(window).height()
      // - A multiple of viewport height - The higher this number the sooner triggered.
      var windowPercentage = $(window).height() * 0.9
      var scrolled = $win.scrollTop()

      /// ////////////////////////////////////
      // Bar Charts scroll activate, looking for .trigger class to fire.
      $('.trigger').each(function () {
        var $this = $(this)
        var offsetTop = $this.offset().top
        if (
          scrolled + windowPercentage > offsetTop ||
          $winHeight > offsetTop
        ) {
          $(this).each(function (key, bar) {
            var percentage = $(this).data('percentage')
            $(this).css('height', percentage + '%')

            /// ////////////////////////////////////
            //        Animated numbers
            $(this).prop('Counter', 0).animate(
              {
                Counter: $(this).data('percentage')
              },
              {
                duration: 2000,
                easing: 'swing',
                step: function (now) {
                  $(this).text(Math.ceil(now))
                }
              }
            )
            //        Animated numbers
            /// ////////////////////////////////////
          })
        } else {
          /// ////////////////////////////////////
          // To keep them triggered, lose this block.
          $(this).each(function (key, bar) {
            $(this).css('height', 0)
          })
        }
      })

      /// ////////////////////////////////////
      // Horizontal Chart
      $('.chartBarsHorizontal .bar').each(function () {
        var $this = $(this)
        var offsetTop = $this.offset().top
        if (
          scrolled + windowPercentage > offsetTop ||
          $winHeight > offsetTop
        ) {
          $(this).each(function (key, bar) {
            var percentage = $(this).data('percentage')
            $(this).css('width', percentage + '%')
            /// ////////////////////////////////////
            //        Animated numbers
            $(this).prop('Counter', 0).animate(
              {
                Counter: $(this).data('percentage')
              },
              {
                duration: 2000,
                easing: 'swing',
                step: function (now) {
                  $(this).text(Math.ceil(now))
                }
              }
            )
            //        Animated numbers
            /// ////////////////////////////////////
          })
        } else {
          /// ////////////////////////////////////
          // To keep them triggered, lose this block.
          $(this).each(function (key, bar) {
            $(this).css('width', 0)
          })
        }
      })
      /// ////////////////////////////////////
      // Pie Charts - scroll activate
      $('.piesite').each(function () {
        var $this = $(this)
        var offsetTop = $this.offset().top
        if (
          scrolled + windowPercentage > offsetTop ||
          $winHeight > offsetTop
        ) {
          if (piesiteFired === 0) {
            $('.piesite').each(function (a) {
            })
            piesiteFired = 1
          }
        } else {
          // To keep them triggered, lose this block.
          $('.piesite').each(function () {
            piesiteFired = 0
          })
        }
      })
    },
    initializeHistogram () {
      var $win = $(window)
      $win.on('scroll', this.scrollReveal)
      this.scrollReveal()
    },
    userSelect (choice) {
      const prev = this.dropDownSelection
      this.dropDownUserSelection = choice
      if (prev !== choice) {
        $('.md-select ul li').each(function () {
          if ($(this).text() === prev) { $(this).removeClass('active') }
          if ($(this).text() === choice) { $(this).addClass('active') }
        })
        this.$store.commit(StateChanges.SET_CHUNKING, choice === 'Divide text into chapters' ? 'DEFAULT' : 'SINGLE')
        this.$store.dispatch(Actions.RUN_CLASSIFICATION)
        this.refreshData()
      }
      setTimeout(this.scrollReveal, 500) // scrollReveal can be effective only after chart is "revealed"
    },
    refreshData () {
      console.log('running refreshData()')
    },
    getInventedData () {
      this.testSetResults = this.$options.inventedData.testSetResults
      // console.log('this.testSetResults:')
      // console.log(this.testSetResults)
    },
    toggleShow (resultIndex) {
      let arrayIndex = resultIndex - 1 // v-for is passing the value of "index" from testSetResults - first is 1
      let tempObj = this.testSetResults[arrayIndex]
      tempObj.show = !(tempObj.show)
      // console.log(this.testSetResults[arrayIndex].show)
      if (tempObj.show) { this.assertText(arrayIndex) }
    },
    assertText (arrayIndex) {
      if (this.testSetResults[arrayIndex].arrangedReviewText.length === 0) {
        const result = this.testSetResults[arrayIndex]
        result.loading = true
        result.timedOut = false
        result.failed = false
        result.allKeys = [result.name] // simplistic
        this.getText(result)
      }
    },
    getText (dataObj) {
      const url = process.env.SERVER_URL + '/DictaDatabaseServer/api/TextFeatures/GetTextLargeAndSmall'
      let requestData = dataObj.allKeys
      const httpClient = axios.create()
      httpClient.defaults.timeout = 10000
      let responseData = httpClient.post(url, requestData).then(response => {
        console.log(response.data)
        if (((typeof response.data) !== 'object') || (!(response.data.length > 0)) || (!(response.data[0].hasOwnProperty('contents'))) || (!(response.data[0].contents.length > 0))) {
          dataObj.loading = false
          dataObj.timedOut = false
          dataObj.failed = true
        } else {
          dataObj.loading = false
          dataObj.failed = false
          dataObj.timedOut = false
          dataObj.arrangedReviewText = this.getArrangedText(response.data)
        }
      }).catch(error => {
        console.log(error)
        dataObj.timedOut = true
        dataObj.loading = false
        dataObj.failed = false
      })
      // return responseData
      console.log(responseData) // so it won't be an unused variable
    },
    getPreviewText (responseObj) {
      const firstTen = _.take(responseObj, 10)
      const contents = _.flatten(firstTen.map(unit => unit.contents))
      return contents.map((smallUnit, index) => smallUnit.smallUnit ? smallUnit.smallUnit : { chunkKey: index, text: '' })
    },
    getArrangedText (responseObj) {
      let flat = this.getPreviewText(responseObj)
      if (!flat || flat.length === 0) {
        return
      }
      let chunks = []
      let pesukim = []
      let chunkID = ''
      let lastValid = ['not yet']
      for (let i = 0; i < flat.length; i++) {
        let nextPasuk = flat[i]
        let indices = bookChapterAndVerse(nextPasuk.chunkKey)
        if (i === 0) {
          chunkID = nextPasuk.chunkKey
          pesukim.push(nextPasuk)
        } else {
          if (indices[0] === lastValid[0] && indices[1] === lastValid[1]) {
            pesukim.push(nextPasuk)
          } else if (indices.length !== 0) {
            chunks.push({'chunkID': chunkID, 'pesukim': pesukim})
            pesukim = [nextPasuk]
            chunkID = nextPasuk.chunkKey
          }
        }
        if (indices.length > 0) { lastValid = indices }
      }
      if (pesukim !== []) { chunks.push({'chunkID': chunkID, 'pesukim': pesukim}) }
      return chunks
    },
    pasukNum: function (key) {
      return bookChapterAndVerse(key)[2]
    },
    pasukHeb: function (key) {
      return numToHebrew(this.pasukNum(key))
    },
    chapterNum: function (key) {
      return bookChapterAndVerse(key)[1]
    },
    chapterHeb: function (key) {
      return numToHebrew(this.chapterNum(key))
    },
    getResultName (result) {
      // FIXME: hack to address the single chunk case, in which the server will return the first key for the chunk
      // instead of all the keys
      if (this.dropDownUserSelection === 'Entire Text (Don’t divide)') {
        return this.testText.displayName
      }
      return result.name.split('/').slice(4, 6).join('/')
    },
    getChunkHeader: function (chunk) {
      // FIXME: hack to address the single chunk case, in which the server will return the first key for the chunk
      // instead of all the keys
      if (this.dropDownUserSelection === 'Entire Text (Don’t divide)') {
        return this.testText.displayName
      }
      let firstKey = chunk.chunkID
      if (firstKey === '') {
        return 'ספר ופרק לא רשומים כמו שצריך'
      } else {
        return bookChapterAndVerse(firstKey)[0] + ' ' + this.chapterNum(firstKey)
      }
    },
    barColor (result) {
      // return { purpleBar: result.classifiedAs === 'Joshua', greenBar: result.classifiedAs === 'Judges' }
      return 'class-' + (result.classID % 5) + '-bar'
    },
    textColor (result) {
      // if (result.classifiedAs === 'Joshua') { return 'pink' } else { return 'green' }
      return 'bg-class bg-class-' + (result.classID % 5)
    },
    focus (oneResult) {
      this.chosenResult = oneResult
      // console.log(this.chosenResult)
    },
    roundConfidence (confidence) {
      return Math.round(confidence * 100)
    },
    scaleConfidence (confidence) {
      // 50% or lower is extremely low confidence
      return Math.max(0, (confidence * 100) - 50) * 2
    }
  },
  watch: {
    classifyState: function () {
      setTimeout(this.scrollReveal, 500) // scrollReveal can be effective only after chart is "revealed"
    },
    '$store.state.testTextResults': {
      handler: function () {
        this.updateTestTextResults()
      },
      immediate: true
    },
    '$store.state.features': {
      handler: function () {
        this.updateTestTextResults()
      },
      immediate: true
    }
  },
  mounted: function () {
    // this.getInventedData()
    // (about to be chucked) this.show.push(false) // index 0 - not used in current testSetResults array
    this.initializeHistogram()
    console.log(this.classes)
    $(document).on('click', '.non-dropdown-closer', function (e) {
      e.stopPropagation()
    })
    $(document).on('click', () => {
      this.view = false
    })
  }
}
</script>
<style scoped>
.error-message {
  direction: ltr;
}
  .no-txt {
    width: 451px;
    overflow: hidden;
    position: relative;
    border-radius: 2px;
    padding: 21px 21px 9px;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.37);
    background-color: #ffffff;
    border: solid 1px #c0c0c0;
  }
  .no-txt:before{
    width: 2px;
    height: 100%;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    background: #ff0000;
  }
  .no-txt .button{
    min-width: 79px;
    height: 28px;
    color: #000;
    box-shadow: none;
    line-height: 28px;
    border-radius: 2px;
    margin: 0 -11px 0 0;
    background-color: #e0e0e0;
  }
  .no-txt .button img{
    display: inline-block;
    vertical-align: middle;
    margin: -1px 0 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/experiment/textClassificationTab.vue